export default {
  routes: [
    {
      path: '/inst/home',
      name: 'inst_home',
      component: () => import('@/module/institution/InstitutionHomePage.vue'),
      meta: {
        title: '机构详情',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/institution/list',
      name: 'institution_list',
      component: () => import('@/module/institution/InstitutionListPage.vue'),
      meta: {
        title: '高级版机构列表',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/institution/list/acticity',
      name: 'institution_acticity',
      component: () => import('@/module/institution/InstitutionActivityMainPage.vue'),
      meta: {
        title: '机构活动',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/institution/message/detail',
      name: 'institution_message_detail',
      component: () => import('@/module/message/InstitutionMessageDetail.vue'),
      meta: {
        title: '通知详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/share',
      name: 'share_page',
      component: () => import('@/module/institution/SharePage.vue'),
      meta: {
        title: '分享',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/activity/share',
      name: 'activity_share_page',
      component: () => import('@/module/institution/ActivitySharePage.vue'),
      meta: {
        title: '活动分享',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/inst/teacher/list',
      name: 'teacher_list',
      component: () => import('@/module/micro/teacherListPage.vue'),
      meta: {
        title: '名师列表',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/inst/teacher/detail',
      name: 'teacher_detail',
      component: () => import('@/module/micro/teacherDetailPage.vue'),
      meta: {
        title: '名师详情',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/inst/course/list',
      name: 'course_list',
      component: () => import('@/module/micro/courseListPage.vue'),
      meta: {
        title: '课程列表',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/inst/course/detail',
      name: 'course_detail',
      component: () => import('@/module/micro/courseDetailPage.vue'),
      meta: {
        title: '课程详情',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/inst/student/detail',
      name: 'student_detail',
      component: () => import('@/module/micro/studentDetailPage.vue'),
      meta: {
        title: '学生详情',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/mine/archives/detail',
      name: 'activity_detail',
      component: () => import('@/module/mine/ArchivesDetailPage.vue'),
      meta: {
        title: '档案详情',
        keepAlive: false,
        logined: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/Inst.js